import React, { memo } from "react";
import useEventList from "./index.hooks";
import { AppPaper, CreateEventDialog, EventEditDialog } from "components";
import { DataGrid } from "@material-ui/data-grid";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";

type EventsListProps = {};

const EventsList = ({}: EventsListProps) => {
  const {
    styles,
    classes,
    t,
    gridData,
    activeCount,
    datagridComponents,
    isMobile,
  } = useEventList();

  return (
    <>
      <AppPaper>
        <Typography variant="h4" color="primary" className={styles.inline}>
          {t("Eventi")}
        </Typography>
        <Typography className={styles.inline}>
          {gridData.rows.length} totali di cui {activeCount} attive
        </Typography>
        <DataGrid
          columnBuffer={2}
          density={isMobile ? "compact" : "standard"}
          components={datagridComponents}
          disableSelectionOnClick
          columns={gridData.cols}
          rows={gridData.rows}
          rowHeight={isMobile ? 500 : 52}
          headerHeight={isMobile ? 10 : 50}
          pageSize={8}
          autoHeight
        />
      </AppPaper>
      <CreateEventDialog />
      <EventEditDialog />
    </>
  );
};

export default memo(EventsList);
